import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'ConditionDocumentalCampaign/GetFunctionToAdd', method: 'GET', token: token })
}
